import _ from 'es-toolkit/compat';
import * as yup from 'yup';

import { SSN_LENGTH } from '@clearverify/constants';

import {
  commercialVerificationRequestTypeOptions,
  VerificationRequestCreateFormFields,
} from 'src/constants/verificationRequest';

const stringValidationSchema = yup.string().nullable();
const requiredStringValidationSchema = stringValidationSchema.required('Required');

export const verificationRequestCreateValidationSchema = yup.object({
  [VerificationRequestCreateFormFields.ssn]: requiredStringValidationSchema.length(
    SSN_LENGTH,
    'Invalid SSN',
  ),
  [VerificationRequestCreateFormFields.employeeFirstName]: stringValidationSchema,
  [VerificationRequestCreateFormFields.employeeLastName]: stringValidationSchema,
  [VerificationRequestCreateFormFields.employeeDateOfBirth]: yup
    .date()
    .required('Please enter date of birth')
    .typeError('Please enter date of birth')
    .min(new Date('1800-01-01'), 'Invalid date of birth'),
  [VerificationRequestCreateFormFields.verificationReportType]:
    requiredStringValidationSchema.oneOf(
      commercialVerificationRequestTypeOptions.map(option => option.value),
    ),
  [VerificationRequestCreateFormFields.permissiblePurposeId]: requiredStringValidationSchema,
  [VerificationRequestCreateFormFields.noteToEmployee]: stringValidationSchema,
  [VerificationRequestCreateFormFields.paymentMethod]: stringValidationSchema.required(),
  [VerificationRequestCreateFormFields.error]: stringValidationSchema.test(_.isNil),
  [VerificationRequestCreateFormFields.employers]: yup
    .array()
    .of(yup.object())
    .min(1, 'At least one Employer must be selected')
    .required('Required')
    .nonNullable(),
});
